export const DEFAULT_ERROR = 'Something went wrong, try again later';
